import { StyleSheet, type BoxShadowValue } from 'react-native'

import { COLOR_BLACK, COLOR_BRAND_ORANGE_500, COLOR_BRAND_YELLOW_600, COLOR_WHITE, getRGBA } from './colors'

const glow: BoxShadowValue = {
  offsetX: 0,
  offsetY: 0,
  blurRadius: 25,
  spreadDistance: 5
}
const hard: BoxShadowValue = {
  offsetX: 0,
  offsetY: 5,
  blurRadius: 5,
  spreadDistance: 0
}
const soft: BoxShadowValue = {
  offsetX: 0,
  offsetY: 0,
  blurRadius: 15,
  spreadDistance: 5
}

export const shadowStyles = StyleSheet.create({
  blackGlow: {
    boxShadow: [
      {
        ...glow,
        color: getRGBA(COLOR_BLACK, 0.75)
      }
    ]
  },
  blackHard: {
    boxShadow: [
      {
        ...hard,
        color: getRGBA(COLOR_BLACK, 0.5)
      }
    ]
  },
  blackSoft: {
    boxShadow: [
      {
        ...soft,
        color: getRGBA(COLOR_BLACK, 0.25)
      }
    ]
  },
  orangeGlow: {
    boxShadow: [
      {
        ...glow,
        color: getRGBA(COLOR_BRAND_ORANGE_500, 0.75)
      }
    ]
  },
  orangeHard: {
    boxShadow: [
      {
        ...hard,
        color: getRGBA(COLOR_BRAND_ORANGE_500, 0.5)
      }
    ]
  },
  orangeSoft: {
    boxShadow: [
      {
        ...soft,
        color: getRGBA(COLOR_BRAND_ORANGE_500, 0.25)
      }
    ]
  },
  yellowGlow: {
    boxShadow: [
      {
        ...glow,
        color: getRGBA(COLOR_BRAND_YELLOW_600, 0.75)
      }
    ]
  },
  whiteGlow: {
    boxShadow: [
      {
        ...glow,
        color: getRGBA(COLOR_WHITE, 0.75)
      }
    ]
  },
  whiteHard: {
    boxShadow: [
      {
        ...hard,
        color: getRGBA(COLOR_WHITE, 0.5)
      }
    ]
  },
  whiteSoft: {
    boxShadow: [
      {
        ...soft,
        color: getRGBA(COLOR_WHITE, 0.25)
      }
    ]
  }
})
